import { render, staticRenderFns } from "./ExamChapterDialog.vue?vue&type=template&id=2ba8a76a&scoped=true&"
import script from "./ExamChapterDialog.vue?vue&type=script&lang=js&"
export * from "./ExamChapterDialog.vue?vue&type=script&lang=js&"
import style0 from "./ExamChapterDialog.vue?vue&type=style&index=0&id=2ba8a76a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8a76a",
  null
  
)

component.options.__file = "ExamChapterDialog.vue"
export default component.exports